export const actionGroupThemes = {
  blue: {
    text: "text-blue-700",
    progress: "bg-blue-700",
    progressBg: "bg-blue-100",
    bg: "bg-sky-50",
    border: "border-blue-600",
  },
  green: {
    text: "text-green-700",
    progress: "bg-green-600",
    progressBg: "bg-green-100",
    bg: "bg-green-50",
    border: "border-green-600",
  },
  violet: {
    text: "text-violet-600",
    progress: "bg-violet-600",
    progressBg: "bg-violet-100",
    bg: "bg-violet-50",
    border: "border-violet-500",
  },
  purple: {
    text: "text-purple-600",
    progress: "bg-purple-600",
    progressBg: "bg-purple-100",
    bg: "bg-purple-50",
    border: "border-purple-600",
  },
  orange: {
    text: "text-orange-600",
    progress: "bg-orange-500",
    progressBg: "bg-orange-100",
    bg: "bg-orange-50",
    border: "border-orange-600",
  },
};

export type ActionGroupThemeName = keyof typeof actionGroupThemes;

export type ActionGroupTheme = (typeof actionGroupThemes)[ActionGroupThemeName];

export const themeNameMappings: Record<number, ActionGroupThemeName> = {
  1: "green",
  2: "blue",
  3: "violet",
  4: "purple",
  5: "orange",
  6: "blue",
  7: "green",
  8: "blue",
};
